import { Form } from "react-bootstrap";

const PaginationLimit = ({itemsPerPage, itemPerChangeHandler}) => {
  return (
    <div className="d-flex">
      Select Limit :
      <Form className="ms-3">
        {["radio"].map((type) => (
          <div key={`inline-${type}`} className="mb-3">
            <Form.Check
              inline
              label="10"
              name="group1"
              type={type}
              checked={itemsPerPage === 10}
              onChange={(e) =>
                e.target.value === "on" && itemPerChangeHandler(10)
              }
              id={`inline-${type}-1`}
            >
              <Form.Check.Input
                type="radio"
                style={{ cursor: "pointer" }}
                onChange={(e) =>
                  e.target.value === "on" && itemPerChangeHandler(10)
                }
                checked={itemsPerPage === 10}
              />
              <Form.Check.Label>10</Form.Check.Label>
            </Form.Check>
            <Form.Check
              inline
              label="25"
              name="group1"
              type={type}
              checked={itemsPerPage === 25}
              onChange={(e) =>
                e.target.value === "on" && itemPerChangeHandler(25)
              }
              id={`inline-${type}-2`}
            >
              <Form.Check.Input
                type="radio"
                style={{ cursor: "pointer" }}
                onChange={(e) =>
                  e.target.value === "on" && itemPerChangeHandler(25)
                }
                checked={itemsPerPage === 25}
              />
              <Form.Check.Label>25</Form.Check.Label>
            </Form.Check>
            <Form.Check
              inline
              label="50"
              name="group1"
              type={type}
              checked={itemsPerPage === 50}
              onChange={(e) =>
                e.target.value === "on" && itemPerChangeHandler(50)
              }
              id={`inline-${type}-3`}
            >
              <Form.Check.Input
                type="radio"
                style={{ cursor: "pointer" }}
                onChange={(e) =>
                  e.target.value === "on" && itemPerChangeHandler(50)
                }
                checked={itemsPerPage === 50}
              />
              <Form.Check.Label>50</Form.Check.Label>
            </Form.Check>
          </div>
        ))}
      </Form>
    </div>
  );
};

export default PaginationLimit;